if(!customElements.get('collapsible-custom-content')) {
    /**
     *  @class
     *  @function CollapsibleCustomContent
     */
    class CollapsibleCustomContent extends HTMLElement {

        constructor() {
            super();
            this.collapsibleContent = document.querySelector('.collapsible-custom-content')
            this.content = document.querySelector('.collapsible-custom-content--content')
            this.btnDisplay = document.querySelector('.collapsible-btn-display')
            this.btnHide = document.querySelector('.collapsible-btn-hide')
            this.addEventListeners()
        }

        addEventListeners() {
            this.btnDisplay.addEventListener('click', () => {
                this.collapsibleContent.classList.add('full-height')
                this.content.style.maxHeight = this.content.scrollHeight + "px";

            })
            this.btnHide.addEventListener('click', () => {
                this.collapsibleContent.classList.remove('full-height')
                window.scrollTo(0, this.collapsibleContent.offsetTop);

                setTimeout(() => {
                    this.content.style.maxHeight = this.content.getAttribute('attr-max-height') + "px";
                }, 200)
                
            })
        }

    }

    customElements.define('collapsible-custom-content', CollapsibleCustomContent);
}

